import React, { createContext, useContext } from 'react';

const ThemeContext = createContext({});
export function useTheme() { return useContext(ThemeContext); }
export function applyThemeVars() {}
export function applyVars() {}
export function ThemeProvider({ children }) {
  return <ThemeContext.Provider value={{}}>{children}</ThemeContext.Provider>;
}
